import { sleep } from "../models/utils";
import { itx } from "../translationItx/itx";

let indicatorNesting = 0;

export async function showGlobalWaitIndicator(show: boolean, text?: string, observeNesting?: boolean): Promise<void> {
  const elm = document.getElementById("globalWaitIndicator") as HTMLDivElement;
  if (elm) {
    if (show) {
      indicatorNesting++;
      elm.style.visibility = "inherit";
    } else {
      indicatorNesting--;
      if (!observeNesting) {
        indicatorNesting = 0;
      }
      if (indicatorNesting <= 0) {
        elm.style.visibility = "hidden";
        indicatorNesting = 0;
      }
    }

    const elmText = document.getElementById("globalWaitIndicatorText") as HTMLDivElement;
    if (elmText) {
      elmText.innerText = text || "";
    }
  }
  await sleep(10);
}

export async function globalWaitIndicatorProgress(percent: number): Promise<void> {
  const elm = document.getElementById("globalWaitIndicatorProgress") as HTMLDivElement;
  if (elm) {
    if (elm) {
      elm.innerText = `${percent}`;
      elm.style.visibility = "visible";
    }
  }
  await sleep(10);
}

export default function GlobalWaitIndicator(props: { text?: string; visible?: boolean }) {
  const { text, visible } = props;

  return (
    <div
      id="globalWaitIndicator"
      style={{
        position: "absolute",
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        visibility: "hidden",
        pointerEvents: "none",
        zIndex: "100",
      }}
    >
      <i className="las la-spin  la-spinner" style={{ fontSize: "3em" }} />
      <div id="globalWaitIndicatorText">{text || itx("globalWaitIndicator.pleaseWait", "please wait ....")}</div>
      <div
        id="globalWaitIndicatorProgress"
        style={{ position: "absolute", visibility: visible ? "inherit" : "hidden" }}
      ></div>
    </div>
  );
}
